<template>
  <div class="py-10">
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        md8
      >
        <v-alert
          :value="alert_error"
          type="error"
          transition="scale-transition"
        >{{errorMessage}}</v-alert>
        <v-alert
          :value="alert_ok"
          type="success"
          transition="scale-transition"
        >{{okMessage}}</v-alert>
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Autenticación</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Usuario"
                prepend-icon="mdi-account-settings"
                type="text"
                v-model="loginUser"
                :rules="[rules.rulesUsuario]"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Contraseña"
                name="password"
                prepend-icon="mdi-account-key"
                type="password"
                v-model="loginPass"
                :rules="[rules.rulesPassword]"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-show="valid"
              @click="login"
            >Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { executeAction } from "../scripts/baseService.js";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      validRetrieve: false,
      passRetrieveDialog: false,
      alert_error: false,
      errorMessage: "",
      okMessage: "",
      alert_ok: false,
      loginUser: "",
      loginPass: "",
      rules: {
        rulesUsuario: (v) => !!v || "Usuario es un campo requerido.",
        rulesPassword: (v) => !!v || "La contraseña es un campo requerido.",
      },
    };
  },
  methods: {
    async login() {
      let jsonData = {
        usuario: this.loginUser,
        contrasena: this.loginPass,
      };

      await executeAction("POST", "Auth/ReportAuth", jsonData, false).then(
        (response) => {
          this.$store.commit("setOverlay", false);
          if (!response.result) {
            this.alert_error = true;
            this.errorMessage = response.errorMessage;
            setTimeout(() => {
              this.alert_error = false;
              this.errorMessage = "";
            }, 5000);
          } else {
            let token = response.payload;
            this.$store.commit("setToken", token);
            this.$router.push({
              path: "/reporte",
            });
          }
        }
      );
    },
  },
  computed: {
    valid() {
      return (
        this.loginPass.length < 40 &&
        this.loginPass.length > 0 &&
        this.loginUser.length > 5
      );
    },
  },
  mounted() {
    this.$store.commit("setToken", null);
  },
  created() {
    this.$store.commit("setIssue", false);
  },
};
</script>

<style>
</style>
